import { CanDeactivateFn, GuardResult, MaybeAsync } from '@angular/router';

export interface CanComponentDeactivate {
  canDeactivate: () => MaybeAsync<GuardResult>;
}

export const pendingChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
): MaybeAsync<GuardResult> => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
